import { useEffect } from "react";

const Scripts = (props: { sources: string[] }) => {
	useEffect(() => {
		for (const s of props.sources) {
			const script = document.createElement("script");
			script.src = s;
			script.async = false;
			document.body.appendChild(script);
		}
	}, [props.sources]);
	return null;
};

export default Scripts;
